const production = {
  url: '/.netlify/functions/',
  useLocalStorage: false, // Assuming you want local storage in production.
  useRemoteStorage: true,
  firebase: {
    apiKey: "AIzaSyAo6GCzSEgGV4NHnMDaIGO9lBgxlYL2RVI",
    authDomain: "madameai.firebaseapp.com",
    projectId: "madameai",
    storageBucket: "madameai.appspot.com",
    messagingSenderId: "96843253648",
    appId: "1:96843253648:web:918d02a18a7ec3abe15515"
  },
  // Firestore database id (prod data lives in the Canada named DB; '(default)' is US).
  // Baked at build time from netlify.toml; defaults to '(default)' until the cutover flip.
  firestoreDatabaseId: process.env.REACT_APP_FIRESTORE_DATABASE_ID || '(default)',
  posthogKey: "phc_rXKj4XiM2xwE5mdOez3pqONJ6ZzsPoVslMpyk6DFU1h",
  posthogHost: "https://us.i.posthog.com",
  sentryDsn: "https://03ea0563fb7bbbb36eb423de94c9528a@o4507562217701376.ingest.us.sentry.io/4507562223665152",
  realtimeEngine: 'elevenlabs', // Options: 'elevenlabs' or 'gemini'
  // Streaming is the default everywhere (parity with dev, where QA validated it).
  // Kill switches without a deploy: ?tts_stream=false / ?turn_stream=false.
  // Pre-audio stream failures fall back to the legacy /upload path on their own.
  ttsStreaming: true, // Streamed TTS playback via the Cloud Run /tts/stream endpoint
  turnStreaming: true, // Streamed conversation turns via the Cloud Run /turn/stream endpoint
  // Cloud Run WebSocket Proxy URLs (secure prompt architecture)
  wsProxyUrl: 'https://madameai-ws-proxy-m3fbnx4poq-nn.a.run.app',
};

const development = {
  url: '/.netlify/functions/', // API url - using relative URL for netlify dev proxy
  useLocalStorage: false, // Assuming you might not need local storage during development.
  useRemoteStorage: true,
  firebase: {
    apiKey: "AIzaSyDBczhS0XYJCVhM3-WemvSFaWliSkjLRIM",
    authDomain: "madameai-dev.firebaseapp.com",
    projectId: "madameai-dev",
    storageBucket: "madameai-dev.firebasestorage.app",
    messagingSenderId: "115515011999",
    appId: "1:115515011999:web:5741e8f267bc35d6b283aa"
  },
  // Dev's (default) DB is already in Canada, so dev/local keep '(default)'.
  firestoreDatabaseId: process.env.REACT_APP_FIRESTORE_DATABASE_ID || '(default)',
  posthogKey: "phc_rXKj4XiM2xwE5mdOez3pqONJ6ZzsPoVslMpyk6DFU1h",
  posthogHost: "https://us.i.posthog.com",
  sentryDsn: "https://03ea0563fb7bbbb36eb423de94c9528a@o4507562217701376.ingest.us.sentry.io/4507562223665152",
  realtimeEngine: 'elevenlabs', // Options: 'elevenlabs' or 'gemini'
  // ON by default (same as prod). Kill switch is ?tts_stream=false.
  ttsStreaming: true,
  // ON by default (same as prod). Kill switch is ?turn_stream=false.
  turnStreaming: true,
  // Cloud Run WebSocket Proxy URLs (secure prompt architecture)
  wsProxyUrl: 'https://madameai-ws-proxy-dev-nuouh24woa-nn.a.run.app',
};

// REACT_APP_FIREBASE_ENV controls which Firebase project to use at build time.
// CRA hardcodes NODE_ENV=production during builds, so we use a custom env var.
// Set REACT_APP_FIREBASE_ENV=development in netlify.toml for deploy previews.
const firebaseEnv = process.env.REACT_APP_FIREBASE_ENV || process.env.NODE_ENV;
export const _config = firebaseEnv === 'development' ? development : production;
